import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchLeadershipAttentionProjects } from "../../../services/leadershipAttentionApi";

export const LEADERSHIP_ATTENTION_QUERY_KEY = "leadership-attention-dashboard";

export const useLeadershipAttentionQuery = (params) =>
  useQuery({
    queryKey: [LEADERSHIP_ATTENTION_QUERY_KEY, params],
    queryFn: () => fetchLeadershipAttentionProjects(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    retry: false,
  });
